<template>
    <div class="new">
        <div class="new-list">
            <div class="header">
                <div class="type-btn active" @click="getNewsAll($event)">{{$t("new.all")}}</div>
                <div class="type-btn" @click="handleGetNewsByType($event, 1)">{{$t("new.tz")}}</div>
                <div class="type-btn" @click="handleGetNewsByType($event, 2)">{{$t("new.wh")}}</div>
                <div class="type-btn" @click="handleGetNewsByType($event, 3)">{{$t("new.hd")}}</div>
                <div class="type-btn" @click="handleGetNewsByType($event, 4)">{{$t("new.zhuanlan")}}</div>
                <div class="type-btn" @click="handleGetNewsByType($event, 5)">{{$t("new.gonglue")}}</div>
            </div>
            <div class="list">
                <div
                    class="item"
                    v-for="news in new_list"
                    :key="news.id"
                    @click="getNewDetail(news.id)"
                >
                    <div class="item-top">
                        <span class="time">{{news.time}}</span>
                        <span :class="{'unread':news.redtitle=='1'}"></span>
                    </div>
                    <div class="item-cont">
                        <span>{{news.title}}</span>
                        <span class="todet"></span>
                    </div>
                </div>
            </div>
            <div class="new-footer">
                <div class="change-page">
                    <span @click="prevPage">{{$t("new.prev")}}</span>
                    <span @click="nextPage">{{$t("new.next")}}</span>
                </div>
                <router-link class="to-index" to="/">{{$t("home")}}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { getNewsList } from "@/api/article.js";

export default {
    name: "New",
    data() {
        return {
            type: 0,
            lang: this.switchLang(
                window.localStorage.getItem("localeLanguage")
            ),
            new_list: [],
            new_list_total: 0,
            limit: 10,
            pages: 1,
            current: 1
        };
    },
    components: {},
    mounted() {
        this.getNewsAll();
    },
    methods: {
        // 全部
        getNewsAll(e) {
            if (e) {
                this.changeBtn(e);
            }
            this.type = 0;
            this.current = 1;
            this.getNewsByType();
        },
        // 通知1, 维护2, 活动3, 专栏4, 攻略5
        handleGetNewsByType(e, type) {
            this.changeBtn(e);
            this.type = type;
            this.current = 1;
            this.getNewsByType();
        },
        // 获取新闻
        getNewsByType() {
            getNewsList({
                lang: this.lang,
                type: this.type,
                page: this.current,
                limit: this.limit
            })
                .then(res => {
                    console.log(res);
                    if (res.code == 1) {
                        this.new_list_total = res.data[0];
                        this.new_list = res.data[1];
                        this.pages =
                            parseInt(this.new_list_total / this.limit) +
                            (this.new_list_total % this.limit > 0 ? 1 : 0);
                    } else {
                        return Promise.reject(res);
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        switchLang(lang) {
            let langtype;
            switch (lang) {
                case "zh-CN":
                    langtype = 1;
                    break;
                case "ja":
                    langtype = 3;
                    break;
                case "en":
                    langtype = 4;
                    break;
                default:
                    langtype = 1;
            }
            return langtype;
        },
        changeBtn(e) {
            $(".new .header .type-btn").removeClass("active");
            $(e.currentTarget).addClass("active");
        },
        // 上一页
        prevPage() {
            if (this.current > 1) {
                this.current--;
                this.getNewsByType();
            }
        },
        nextPage() {
            if (this.current < this.pages) {
                this.current++;
                this.getNewsByType();
            }
        },
        // 路由跳转到 新闻详细页面
        getNewDetail(id) {
            this.$router.push({
                name: "new_detail",
                params: {
                    id: id
                },
                query: {
                    id: id
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.new {
    width: 100%;
    padding: 40px 0;
    display: flex;
    justify-content: center;
    .new-list {
        width: 70%;
        .header {
            width: 90%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            .type-btn {
                color: #fff4d8;
                background: url("~@assets/imgs/sec-btn.png") no-repeat;
                background-size: 100% 100%;
                padding: 10px 0;
                text-align: center;
                cursor: pointer;
                width: 15%;
                min-width: 50px;
                height: 50px;
                line-height: 30px;
                font-size: 1.2em;
            }
            .type-btn.active {
                background: url("~@assets/imgs/sec-btn-active.png") no-repeat;
                background-size: 100% 100%;
            }
        }
        .list {
            margin-top: 20px;
            min-height: 300px;
            .item {
                margin: 10px 0;
                background: url("~@assets/imgs/new-item-bg.png") center top
                    no-repeat;
                background-size: 100% 100%;
                padding: 5px 20px 15px;
                cursor: pointer;
                .unread {
                    display: block;
                    width: 10px;
                    height: 10px;
                    float: right;
                    background: url("~@assets/imgs/new-item-unread.png")
                        no-repeat;
                    background-size: 100% 100%;
                }
                .item-cont {
                    font-weight: bold;
                    .todet {
                        display: block;
                        width: 10px;
                        height: 20px;
                        float: right;
                        background: url("~@assets/imgs/new-item-todet.png")
                            no-repeat;
                        background-size: 100% 100%;
                        position: relative;
                        right: 5px;
                        bottom: 3px;
                    }
                }
            }
        }
        .new-footer {
            display: flex;
            justify-content: center;
            .change-page {
                display: flex;
                justify-content: center;
                margin-right: 40px;
            }
            .change-page span,
            .to-index {
                display: block;
                color: #fff;
                padding: 5px 20px;
                margin: 0 10px;
                background: url("~@assets/imgs/sec-btn.png") no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                opacity: 0.8;
            }
            .change-page span:hover,
            .to-index:hover {
                opacity: 1;
            }
            .to-index {
                padding: 5px 30px;
            }
        }
    }
}
// 适配小屏
@media screen and (max-width: 768px) {
    .new {
        padding: 20px 0;
        .new-list {
            width: 95%;
            .header {
                .type-btn {
                    height: 30px;
                    line-height: 30px;
                    padding: 0 5px;
                    font-size: 14px;
                }
            }
            .new-footer {
                .change-page span,
                .to-index {
                    padding: 5px 10px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/New_list.vue